import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChanges: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChanges"><Path d="M20.5 3.5H3.5V20.5H20.5V3.5Z" stroke="currentColor"/><Path d="M12 7V10.5M12 14V10.5M12 10.5H8.5M12 10.5H15.5" stroke="currentColor"/><Path d="M8.5 16.5H15.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconChanges;
